@if (isSimulationEditorVisible) {
  <div
    class="simulation-editor-banner position-absolute top-0 start-50 translate-middle-x mt-3 px-3 py-2 rounded-2 shadow-sm"
  >
    <div class="simulation-editor-banner__content">
      <span class="simulation-editor-banner__title">Editor mode</span>
      <span class="simulation-editor-banner__text"
        >Create local simulation sets you can import, export, and later push as a batch.</span
      >
    </div>
  </div>
}

<ng-template #editorIntroDialog>
  <app-simulation-editor-intro-dialog
    [dontShowAgain]="editorIntroDontShowAgain"
    [showDontShowAgain]="shouldShowEditorIntroCheckbox"
    (dontShowAgainChange)="editorIntroDontShowAgain = $event"
  ></app-simulation-editor-intro-dialog>
</ng-template>

<div class="position-absolute bottom-7 start-20">
  <app-scale-control> </app-scale-control>
</div>
<div
  class="position-absolute translate-middle-x bottom-7 start-50 col"
  [class.d-none]="allowedFilters.length <= 1"
  data-cy="dropdown-warnings-menu"
  *ngIf="!isSimulationEditorVisible"
>
  <div isDemoEnabled ngbDropdown placement="top" class="d-inline-block">
    <button
      type="button"
      class="simulation-page-panel simulation-page-button btn btn-outline-primary z-3 shadow-sm rounded-2 cursor-pointer border"
      id="dropdownBasic1"
      ngbDropdownToggle
      data-cy="dropdown-warnings-toggle"
    >
      {{ this.currentFilter.split('.')[1] }}
    </button>
    <div
      isDemoEnabled
      ngbDropdownMenu
      class="simulation-page-panel simulation-page-menu z-3 shadow-sm rounded-2 cursor-pointer border"
      aria-labelledby="dropdownBasic1"
      dropdownWarningsToggle
    >
      <div *ngFor="let filter of allowedFilters">
        <button
          ngbDropdownItem
          class="simulation-page-menu-item z-3 rounded-2 cursor-pointer"
          (click)="setCurrentFilter(filter)"
          data-cy="dropdown-warnings-item"
        >
          {{ filter }}
        </button>
      </div>
    </div>
  </div>
</div>
<app-bottom-page-panel *ngIf="!isSimulationEditorVisible">
  <app-auto-refresh
    (intervalSet)="setLiveModeRefreshInterval($event)"
    [isActive]="isInLiveMode"
    [isDisabled]="isHistoryVisible"
    [intervalInSecondsInput]="displayRefreshInterval"
  ></app-auto-refresh>
</app-bottom-page-panel>
<app-map-navigation>
  <app-simulation-view-actions-bar
    [isHexagonWarningCreationVisible]="isHexagonWarningCreationVisible"
    [isRoadWarningCreationVisible]="isRoadWarningCreationVisible"
    [isSimulationEditorVisible]="isSimulationEditorVisible"
    [highlightNewEditor]="showEditorMenuHighlight"
    (toggleHexagonWarning)="enableSetHexagonWarningMode()"
    (toggleRoadWarning)="enableSetRoadWarningMode()"
    (toggleEditor)="enableWarningImportExport()"
  ></app-simulation-view-actions-bar>
</app-map-navigation>
<app-simulation-warnings-editor
  (closed)="closeImportExport()"
  (helpRequested)="openEditorHelpDialog()"
  [isVisible]="isSimulationEditorVisible"
></app-simulation-warnings-editor>
<app-simulation-layer-config *ngIf="!isSimulationEditorVisible"></app-simulation-layer-config>
<app-simulation-warnings-details></app-simulation-warnings-details>
<app-simulation-area-warnings-details></app-simulation-area-warnings-details>
<app-simulation-create-warnings-details
  [isSimulationEditorVisible]="isSimulationEditorVisible"
></app-simulation-create-warnings-details>
<app-simulation-create-area-warnings-details
  [isSimulationEditorVisible]="isSimulationEditorVisible"
></app-simulation-create-area-warnings-details>
<app-last-backend-call></app-last-backend-call>
